import React from "react";
import "./Skills.css";

import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaPython,
  FaGitAlt,
  FaDatabase,
} from "react-icons/fa";

const skills = [
  {
    name: "HTML",
    percentage: 95,
    icon: <FaHtml5 />,
    category: "Frontend",
  },
  {
    name: "CSS",
    percentage: 90,
    icon: <FaCss3Alt />,
    category: "Frontend",
  },
  {
    name: "JavaScript",
    percentage: 85,
    icon: <FaJs />,
    category: "Frontend",
  },
  {
    name: "React",
    percentage: 80,
    icon: <FaReact />,
    category: "Frontend",
  },
  {
    name: "Python",
    percentage: 90,
    icon: <FaPython />,
    category: "Backend",
  },
  {
    name: "MySQL",
    percentage: 80,
    icon: <FaDatabase />,
    category: "Database",
  },
  {
    name: "Git & GitHub",
    percentage: 75,
    icon: <FaGitAlt />,
    category: "Tools",
  },
];

const Skills = () => {
  return (
    <section className="skills">

      {/* Heading */}
      <div className="skills-heading">

        <p className="skills-subtitle">
          MY TECHNICAL EXPERTISE
        </p>

        <h2>My Skills</h2>

        <div className="skills-line"></div>

        <p className="skills-description">
          Technologies and tools I use to build responsive,
          functional and user-friendly web applications.
        </p>

      </div>


      {/* Skills Grid */}
      <div className="skills-container">

        {skills.map((skill, index) => (

          <div className="skill-card" key={index}>

            {/* Card Top */}
            <div className="skill-header">

              <div className="skill-info">

                <div className="skill-icon">
                  {skill.icon}
                </div>

                <div>
                  <h3>{skill.name}</h3>
                  <p>{skill.category}</p>
                </div>

              </div>

              <span className="percentage">
                {skill.percentage}%
              </span>

            </div>


            {/* Progress */}
            <div className="progress-container">

              <div className="progress-background">

                <div
                  className="progress"
                  style={{
                    width: `${skill.percentage}%`,
                  }}
                ></div>

              </div>

            </div>

          </div>

        ))}

      </div>


      {/* Bottom Section */}
      <div className="skills-footer">

        <h3>Always Building & Improving</h3>

        <p>
          I continuously practice my skills by building projects,
          working with APIs and exploring modern development tools.
        </p>

      </div>

    </section>
  );
};

export default Skills;